import React, {createContext, ReactNode, useContext, useState} from 'react'
import {PlayerColor} from '@colonist/game-states'

interface UIGameMyColorContextProps {
    myColor: PlayerColor
    setMyColor: (color: PlayerColor) => void
}

const UIGameMyColorContext = createContext<UIGameMyColorContextProps | undefined>(undefined)

export const useUIGameMyColorContext = () => {
    const context = useContext(UIGameMyColorContext)
    if(!context) throw new Error('UIGameMyPlayerContext not found')
    return context
}

interface UIGameMyColorProviderProps {
    myColor: PlayerColor
    children: ReactNode
}

export const UIGameMyColorProvider = ({
    myColor: defaultMyColor,
    children,
}: UIGameMyColorProviderProps) => {
    const [myColor, setMyColor] = useState<PlayerColor>(defaultMyColor)

    return <UIGameMyColorContext.Provider value={{
        myColor: myColor,
        setMyColor: setMyColor,
    }}>
        {children}
    </UIGameMyColorContext.Provider>
}
